module.exports = __webpack_public_path__ + "img/logo3.7e38a9a8.png";